import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';

import boxSrc from '../../assets/images/game/box.webp';
import boxSrc2x from '../../assets/images/game/box@2x.webp';

import styles from '../../styles/modules/game/Game.module.scss';

import { useGameStore } from '../../store/useGameStore';
import { useConfigStore } from '../../store/useConfigStore';

import Modal from '../modal/Modal';

const BOX_SPAWN_OFFSET = -100;
const BOX_SPEED_PX_PER_MS = 0.06;
const MAX_FRAME_MS = 50;

const GameBox = ({ id, feedIdx, onRemoveBox }) => {
	const [openedIds, setOpenedIds] = useState([]);

	const { openModal } = useConfigStore((s) => s);
	const { switchAnimation } = useGameStore();

	const boxRef = useRef(null);

	useEffect(() => {
		const boxElement = boxRef.current;
		if (!boxElement) return;

		const boxesElement = boxElement.parentElement;
		const platformElement = document.querySelector(`.${styles.bridge}`);

		const platformBottom =
			boxesElement && platformElement
				? platformElement.getBoundingClientRect().bottom - boxesElement.getBoundingClientRect().top
				: 0;

		let progress = BOX_SPAWN_OFFSET;
		let frameId = 0;
		let lastTime = 0;

		const animate = (time) => {
			const removePoint = (boxesElement?.offsetHeight ?? 0) + 80;

			progress += lastTime ? Math.min(time - lastTime, MAX_FRAME_MS) * BOX_SPEED_PX_PER_MS : 0;

			lastTime = time;

			const opacity = Math.min((progress - BOX_SPAWN_OFFSET) / 80, 1);
			const isBehindPlatform = progress < platformBottom;

			boxElement.style.top = `${progress}px`;
			boxElement.style.opacity = `${opacity}`;
			boxElement.style.pointerEvents = opacity < 1 || isBehindPlatform ? 'none' : 'auto';

			if (progress >= removePoint) {
				onRemoveBox(id);
				return;
			}

			frameId = requestAnimationFrame(animate);
		};

		frameId = requestAnimationFrame(animate);

		return () => {
			cancelAnimationFrame(frameId);
		};
	}, [id, onRemoveBox]);

	const openBoxHandler = () => {
		openModal(Modal);

		if (openedIds.includes(id)) return;

		setOpenedIds((prev) => [...prev, id]);

		switchAnimation(feedIdx);

		setTimeout(() => {
			onRemoveBox(id);
		}, 220);
	};

	const isOpened = openedIds.includes(id);

	return (
		<div
			ref={boxRef}
			className={cx(styles.box, { [styles.selected]: isOpened })}
			onClick={openBoxHandler}
			style={{
				position: 'absolute',
				left: '50%',
				top: `${BOX_SPAWN_OFFSET}px`,
				opacity: 0,
				pointerEvents: 'none',
			}}
		>
			<img src={boxSrc} srcSet={`${boxSrc} 1x, ${boxSrc2x} 2x`} alt='' />
		</div>
	);
};

export default GameBox;
